import { ColorUtils } from '@/model/project/utils/colorutils'
import { TextInputProperty } from "./properties/textinputproperty";
import { FillColorProperty } from "./properties/fillcolorproperty";
import { TextColorProperty } from "./properties/textcolorproperty";
import { StringUtils } from "../utils/stringutils";
import Konva from "konva";
import { Button } from './button';

export class RectJumpButton extends Button {

  public drawObject(): void {
    super.initObject();

    let fillcolor = this.fillcolor;
    const fillprop = this.properties['fillcolor'];
    if (fillprop != null) {
      const fillcolorproperty: FillColorProperty = Object.assign(new FillColorProperty(), fillprop);
      if (fillcolorproperty != null)
        fillcolor = fillcolorproperty.getColor(this.tagnames, this.fillcolor)
    }
    const fillcolor2 = ColorUtils.convertformat(fillcolor);


    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const gradient = ctx.createLinearGradient(0, 0, 0, this.height);
    gradient.addColorStop(0, 'white')
    gradient.addColorStop(1, ColorUtils.darkColor(fillcolor2, 0.5))

    const rect = new Konva.Rect({
      x: this.width / 68,
      y: this.width / 68,
      width: this.width - this.width / 34,
      height: this.height - this.width / 34,
      stroke: this.type3d == 0 ? gradient : ColorUtils.darkColor(fillcolor2, 0.75),
      strokeWidth: this.width / 34

    });
    if (this.type3d == 0) {
      rect.fillLinearGradientStartPoint({ x: this.width / 68, y: this.width / 68 });
      rect.fillLinearGradientEndPoint({ x: this.width / 68, y: this.height - this.width / 34 });
      rect.fillLinearGradientColorStops([0, ColorUtils.darkColor(fillcolor2, 0.5),
        1, 'white']);
    } else {
      rect.fill(fillcolor2)
    }
    this.node.add(rect);

    let textoutput = this.text;
    const textprop = this.properties['textinput']
    if (textprop != null) {
      const textinputproperty: TextInputProperty = Object.assign(new TextInputProperty(), textprop);
      if (textinputproperty != null)
        textoutput = textinputproperty.getCurrentText(this.tagnames, this.text);
    }
    let textcolor = this.textcolor;
    const textcolorprop = this.properties['textcolor'];
    if (textcolorprop != null) {
      const textcolorproperty: TextColorProperty = Object.assign(new TextColorProperty(), textcolorprop);
      if (textcolorproperty != null)
        textcolor = textcolorproperty.getColor(this.tagnames, this.textcolor)
    }
    if (textoutput.includes("\\n")) {
      textoutput = textoutput.replace(/\\n/g, "\n");
      const textouts = textoutput.split("\n");
      const deltay = this.height * 0.7 / textouts.length;
      let deltaymid = this.height / 10;
      for (const textout of textouts) {
        const Text = new Konva.Text({
          x: this.height / 20,
          y: deltaymid,
          verticalAlign: "bottom",
          width: this.width - this.height / 10,
          height: deltay,
          text: textout,
          fontSize: this.fontsize,
          fontFamily: StringUtils.getFontFamily(this.fonttype),
          fontStyle: StringUtils.getFontStyle(this.fonttype),
          align: StringUtils.getTextPlacement(this.textplacement),
          fill: ColorUtils.convertformat(textcolor),
          textDecoration: this.underline ? "underline" : ""
        });
        this.node.add(Text);
        deltaymid += deltay;
      }
    }
    else {
      const Text = new Konva.Text({
        x: this.width / 17,
        y: 0,
        verticalAlign: "middle",
        width: this.width - 2 * this.width / 17,
        height: this.height,
        text: textoutput,
        fontSize: this.fontsize == 0 ? this.height / 4 : this.fontsize,
        fontFamily: StringUtils.getFontFamily(this.fonttype),
        fontStyle: StringUtils.getFontStyle(this.fonttype),
        align: StringUtils.getTextPlacement(this.textplacement),
        fill: ColorUtils.convertformat(textcolor),
        textDecoration: this.underline ? "underline" : ""
      });

      if (this.type3d == 0) {

        Text.shadowColor('black'),
          Text.shadowBlur(0),
          Text.shadowOffset({ x: 1, y: 1 })
      }

      this.node.add(Text)
    }
    this.setFunctions();


  }

}